import React from 'react';
import UserMaintaneneceContent from '../function-components/UserMaintenance/UserMaintaneneceContent';

const userMaintenancePage = () => {
  return (
    <UserMaintaneneceContent />
  )
}

export default userMaintenancePage